<kt-base-modal [title]="shiftInfo?.timesheet?.active_loop?.loop?.loop_name || loopDetail?.loop_name">
  <div modal-body>
    <kt-loader [showLoader]="loading()">
      <div>
        <div class="row">
          <div class="col-md-6">
            <b>Loop Name:</b> {{ shiftInfo?.timesheet?.active_loop?.loop?.loop_name || loopDetail?.loop_name}}
          </div>
          <div class="col-md-2">
            <b>Loop Multiple:</b> {{ shiftInfo?.timesheet?.active_loop?.loop?.loop_multiple ||
            loopDetail?.loop_multiple_count || 0}}
          </div>
          <div class="col-md-2">
            <b>Reward Point:</b>{{ shiftInfo?.timesheet?.active_loop?.loop?.loop_reward_point ||
            loopDetail?.loop_reward_point}}
          </div>
          <div class="col-md-2">
            <b>Loop Buffer:</b> {{ shiftInfo?.timesheet?.active_loop?.loop.loop_buffer_time ||
            loopDetail?.loop_buffer_time}}
          </div>
        </div>
        <div *ngIf="viewMode && actualLoop" class="d-flex justify-content-around align-items-center bg-light p-2">
          <div>
            <b>Start Time: </b>{{actualLoop?.timesheet_log_start_date | TimezoneDateTime}}
          </div>
          <div>
            <b>End Time: </b>{{actualLoop?.timesheet_log_end_date | TimezoneDateTime}}
          </div>
        </div>


        <div class="kt-timeline-v2 my-4">
          <div class="kt-timeline-v2__items  kt-padding-top-25 kt-padding-bottom-30">
            <ng-container *ngFor="let loop of  loopSequences">
              <div class="kt-timeline-v2__item">
                <span *ngIf="!viewMode" class="kt-timeline-v2__item-time" style="width: 200px; text-align: left;">
                  {{loop.expectedStartAt | TimezoneDateTime}}
                </span>
                <span *ngIf="viewMode" class="kt-timeline-v2__item-time">
                  Duration: {{loop.loop_sequence_interval}}
                </span>
                <div class="kt-timeline-v2__item-cricle">
                  <svg-icon class="svg_icon17x17 danger-config-color d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/radio.svg"></svg-icon>
                </div>
                <div class="kt-timeline-v2__item-text">
                  <b>{{loop?.area?.area_name}}</b>
                  <a href="javascript:;" *ngIf="!viewMode" style="cursor: pointer;"
                    (click)="areaClickHandler(loop.area, loop)"
                    class="kt-link kt-link--brand kt-font-bolder m-2">Scan</a>
                  <br />
                  <span *ngIf="showNoOfScan">
                    Scanned {{loop.timesheet_transaction?.length ? loop.timesheet_transaction?.length : 0}} Times
                    <ng-container *ngFor="let item of loop.timesheet_transaction">
                      <div>
                        {{item.timesheet_transaction_created_at | TimezoneDateTime}}
                      </div>
                    </ng-container>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
        </kt-button>
        <button class="btn btn-brand" *ngIf="!viewMode" (click)="endLoopHandler()">End Loop</button>
      </div>
    </kt-loader>

  </div>

</kt-base-modal>